module.exports = __webpack_public_path__ + "static/media/importICS2.8760e047.png";